export default "__VITE_ASSET__478848f4__"